import React from "react";

import {timeString} from "../../../../services/date/formatters";
import TimeAttributeForm from "../../../../components/AttributeForm/TimeAttributeForm";
import TextAttributeForm from "../../../../components/AttributeForm/TextAttributeForm";
import RadioGroupForm from "../../../../components/AttributeForm/RadioGroupForm";
import {ARRIVAL_DAY, CATEGORY} from "../../../../services/homes/enums";
import AttributeList from "../../../../components/AttributeList";
import {useHome} from "../HomeContext";
import {useHomeAction} from "../HomeActionContext";
import {emailValidationSchema} from "../homeValidationSchema";

import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import PhoneIcon from "@mui/icons-material/Phone";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import StarIcon from '@mui/icons-material/Star';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import VisibilityIcon from '@mui/icons-material/Visibility';

const HomeInfo = () => {

    const {
        mail,
        phone,
        mobilePhone,
        category,
        arrivalDay,
        checkIn,
        checkOut,
        cirCode,
        cinCode,
        visible
    } = useHome();

    const {
        formEmail,
        formPhone,
        formMobilePhone,
        formCategory,
        formArrivalDay,
        formCheckIn,
        formCheckOut,
        formCirCode,
        formCinCode,
        formVisible,
        handleSubmit
    } = useHomeAction();

    const attributes = [
        {
            label: "Email",
            value: mail,
            defaultValue: "Non presente",
            icon: <AlternateEmailIcon/>,
            formDialog: formEmail,
            formComponent: <TextAttributeForm attribute="mail"
                                              label="Email"
                                              value={mail}
                                              validationSchema={emailValidationSchema}
                                              onClose={formEmail.close}
                                              onSubmit={(data) => handleSubmit(formEmail, data)}
                                              isLoading={formEmail.loading}/>
        },
        {
            label: "Telefono",
            value: phone,
            defaultValue: "Non presente",
            icon: <PhoneIcon/>,
            formDialog: formPhone,
            formComponent: <TextAttributeForm attribute="phone"
                                              label="Telefono"
                                              value={phone}
                                              onClose={formPhone.close}
                                              onSubmit={(data) => handleSubmit(formPhone, data)}
                                              isLoading={formPhone.loading}/>
        },
        {
            label: "Cellulare",
            value: mobilePhone,
            defaultValue: "Non presente",
            icon: <PhoneAndroidIcon/>,
            formDialog: formMobilePhone,
            formComponent: <TextAttributeForm attribute="mobilePhone"
                                              label="Cellulare"
                                              value={mobilePhone}
                                              onClose={formMobilePhone.close}
                                              onSubmit={(data) => handleSubmit(formMobilePhone, data)}
                                              isLoading={formMobilePhone.loading}/>
        },
        {
            label: "Categoria",
            value: category === 1 ? "1 stella" : `${category} stelle`,
            defaultValue: "Non presente",
            icon: <StarIcon/>,
            formDialog: formCategory,
            formComponent: <RadioGroupForm attribute="category"
                                           label="Categoria"
                                           value={category}
                                           options={[
                                               {label: CATEGORY[1], value: 1},
                                               {label: CATEGORY[2], value: 2},
                                               {label: CATEGORY[3], value: 3},
                                               {label: CATEGORY[4], value: 4},
                                               {label: CATEGORY[5], value: 5}
                                           ]}
                                           onClose={formCategory.close}
                                           onSubmit={(data) => handleSubmit(formCategory, data)}
                                           isLoading={formCategory.loading}/>
        },
        {
            label: "Codice CIR",
            value: cirCode,
            defaultValue: "Non presente",
            icon: "CIR",
            formDialog: formCirCode,
            formComponent: <TextAttributeForm attribute="cirCode"
                                              label="Codice CIR"
                                              value={cirCode}
                                              onClose={formCirCode.close}
                                              onSubmit={(data) => handleSubmit(formCirCode, data)}
                                              isLoading={formCirCode.loading}/>
        },
        {
            label: "Codice CIN Struttura",
            value: cinCode,
            defaultValue: "Non presente",
            icon: "CIN",
            formDialog: formCinCode,
            formComponent: <TextAttributeForm attribute="cinCode"
                                              label="Codice CIN"
                                              value={cinCode}
                                              onClose={formCinCode.close}
                                              onSubmit={(data) => handleSubmit(formCinCode, data)}
                                              isLoading={formCinCode.loading}/>
        },
        {
            label: "Giorno di arrivo predefinito",
            value: ARRIVAL_DAY[arrivalDay],
            defaultValue: "Non presente",
            icon: <CalendarTodayIcon/>,
            formDialog: formArrivalDay,
            formComponent: <RadioGroupForm attribute="arrivalDay"
                                           label="Giorno di arrivo predefinito"
                                           value={arrivalDay}
                                           options={Object.keys(ARRIVAL_DAY).map(v => ({value: v, label: ARRIVAL_DAY[v]}))}
                                           onClose={formArrivalDay.close}
                                           onSubmit={(data) => handleSubmit(formArrivalDay, data)}
                                           isLoading={formArrivalDay.loading}/>
        },
        {
            label: "Orario check-in predefinito",
            value: checkIn ? timeString(checkIn) : null,
            defaultValue: "Non presente",
            icon: <AccessTimeIcon/>,
            formDialog: formCheckIn,
            formComponent: <TimeAttributeForm attribute="checkIn"
                                              label="Orario check-in predefinito"
                                              value={checkIn}
                                              onClose={formCheckIn.close}
                                              minutesStep={15}
                                              onSubmit={(data) => handleSubmit(formCheckIn, data)}
                                              isLoading={formCheckIn.loading}/>
        },
        {
            label: "Orario check-out predefinito",
            value: checkOut ? timeString(checkOut) : null,
            defaultValue: "Non presente",
            icon: <AccessTimeIcon/>,
            formDialog: formCheckOut,
            formComponent: <TimeAttributeForm attribute="checkOut"
                                              label="Orario check-out predefinito"
                                              value={checkOut}
                                              onClose={formCheckOut.close}
                                              minutesStep={15}
                                              onSubmit={(data) => handleSubmit(formCheckOut, data)}
                                              isLoading={formCheckOut.loading}/>
        },
        {
            label: "Visibilità online",
            value: visible ? "La struttura è visibile online" : "La struttura non è visibile online",
            defaultValue: "Non presente",
            icon: <VisibilityIcon/>,
            formDialog: formVisible,
            formComponent: <RadioGroupForm attribute="visible"
                                           label="Visibilità online"
                                           value={visible ? "true" : "false"}
                                           options={[
                                               {label: "Pubblica la struttura online", value: "true"},
                                               {label: "Non pubblicare la struttura online", value: "false"},
                                           ]}
                                           onClose={formVisible.close}
                                           onSubmit={(data) => handleSubmit(formVisible, data)}
                                           isLoading={formVisible.loading}/>
        }
    ]

    return <AttributeList attributes={attributes}/>
}

export default HomeInfo;